module.exports = __webpack_public_path__ + "static/assets/e707e02b4e732af723a0cdcde942fe68.png";